import React from "react";
import InKindPhone from "../images/inkind_phone.png";
import InKindLogo from "../../../../assets/images/checkout/inkind_white.png";
import { useSelector } from "react-redux";
import SubscriptionCard from "./SubscriptionCard";
import numeral from "numeral";

const ConfirmationPanel = () => {
  const nav = useSelector((state) => state.nav);
  const ikPass = useSelector((state) => state.nav.ikPass);
  const ikPassSingle = useSelector((state) => state.nav.ikPassSingle);
  const path = !!ikPassSingle ? "transaction" : "purchase";
  const keep_bonus_amount = nav?.purchaseResponse?.keep_gift_bonus == "true";
  const isSubscription = useSelector((state) => state.nav.subscription);

  const credit_to_give = !!isSubscription
    ? null
    : !ikPass
      ? numeral(nav.purchaseResponse[path].credit_to_give).format("$0,0[.]00")
      : numeral(nav.purchaseResponse.amount_credited).format("$0,0[.]00");
  const purchase_amount = !!isSubscription
    ? null
    : !ikPass
      ? numeral(
          nav.purchaseResponse[path].amount ??
            nav.purchaseResponse[path].amount_to_charge,
        ).format("$0,0[.]00")
      : numeral(nav.purchaseResponse.amount_charged).format("$0,0[.]00");
  const credit_balance = !!isSubscription
    ? null
    : !ikPass
      ? numeral(
          nav.purchaseResponse.credit_balance || nav.purchaseResponse.balance,
        ).format("$0,0[.]00")
      : numeral(nav.purchaseResponse.amount_credited).format("$0,0[.]00");

  return (
    <div>
      {!!isSubscription ? (
        <div className="order-details">
          <SubscriptionCard />
        </div>
      ) : (
        <div className="phone-container confirm-right">
          <img src={InKindPhone} className="phone" alt="Balance" />
          <div className="centered">
            <img src={InKindLogo} alt="inKind" className="logo" />
            {nav.gift ? (
              <>
                <div
                  className={`larger-font font-bold ${
                    purchase_amount.length > 7 || credit_to_give.length > 7
                      ? "longer-number"
                      : ""
                  }`}
                >
                  {keep_bonus_amount ? purchase_amount : credit_to_give}
                </div>
                <div className="balance-text">Gifted Amount</div>
              </>
            ) : (
              <>
                <div
                  className={`larger-font font-bold ${
                    credit_balance.length > 7 ? "longer-number" : ""
                  }`}
                >
                  {credit_balance}
                </div>
                <div className="balance-text">New balance</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmationPanel;
